import { createSelector } from "reselect";

const getIds = (state) => state.blog.data;
const getRelatedIds = (state) => state.blog.related;
const getBlog = (state) => state.entities.blog;

/*****************
 *
 * EXPORT METHODS
 *
 *****************/

export const hasMorePages = (state) =>
    state.blog.pagination
        ? state.blog.pagination.current_page < state.blog.pagination.last_page
        : true;
export const getBlogListPagination = (state) => state.blog.pagination;

export const getBlogList = (state, limit = null) =>
    createSelector(getIds, getBlog, (ids, blog) => {
        let blogIds = ids.slice();
        if (limit) {
            blogIds = blogIds.slice(0, limit);
        }
        return blogIds.map((id) => {
            return blog[id];
        });
    })(state);

export const getArticle = (state, slug) =>
    createSelector(getBlog, (blog) => {
        if (!blog[slug]) return null;
        return blog[slug];
    })(state);

export const getRelatedArticles = (state) =>
    createSelector(getRelatedIds, getBlog, (ids, blog) => {
        return ids.map((id) => {
            return blog[id];
        });
    })(state);
